import { Component, OnInit } from '@angular/core';
import { Constants } from 'src/app/constants';

@Component({
    selector: 'app-lios-navbar',
    templateUrl: './lios-navbar.component.html',
    styleUrls: ['./lios-navbar.component.scss'],
    standalone: false
})
export class LiosNavbarComponent implements OnInit {
  constants: Constants = new Constants()
  menuItems = this.constants.liosMenuItems;
  constructor() { }

  ngOnInit(): void {
   console.info('something')
  }

}
